import { updateNewCompanyPermissions } from "@/utils/update-new-company-permissions";
import { trpc } from "@api/client";
import { usePermissions } from "@flash-tecnologia/hros-web-utility";

export const useAddCompaniesToGroup = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  const permissions = usePermissions();

  const { isPending: isLoading, mutateAsync: addCompaniesToGroup } =
    trpc.addCompaniesToGroup.useMutation({
      onSuccess: (result) => {
        updateNewCompanyPermissions(
          permissions,
          result.companies.map(({ _id, name, registrationNumber }) => ({
            _id,
            name,
            registrationNumber,
          }))
        );

        onSuccess?.();
      },
    });

  return { isLoading, addCompaniesToGroup };
};
